const livingStatusList = [
  "Permanent Housing - Living in a permanent, single-home dwelling",
  "Foster Family Home or Kinship Placement",
  "Health Institution",
  "Hotels/Motels",
  "Licensed Children's Institution",
  "Residential School/ Dormitory",
  "Temporarily Doubled/Tripled Up - with an adult that is not the parent/guardian",
  "Temporarily Doubled/Tripled Up",
  "Temporarily Unsheltered - In a car, park, trailer, or campsite",
  "Temporarily Unsheltered",
  "Temporary Shelter - In a shelter",
  "Temporary Shelter - In a transitional Housing Program",
  // "Development Center",
  // "Incarceration Institution",
  // "State Hospital",
  // "Temporarily Doubled/Tripled Up - with an adult that is not the parent/guardian",
  // "Temporarily Unsheltered - In a rented garage due to loss of housing",
  // "Temporarily Unsheltered - In a rented trailer/motor home or private property",
];

export default livingStatusList;
